<template>
  <div id="footer" class="container">
    <img alt="oro logo" id="logoFooter" src="/img/logo.ba043c74.png" class="col-3">
    <div>oro.gg &copy;{{year}}</div>
    <div>
      <a href="https://www.instagram.com/_oro.gg/" target="_blank" class="link">
        Follow me <font-awesome-icon :icon="['fab', 'instagram']" size="lg" /> _oro.gg
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
  },
  mounted() {},
  data: function (){
    return {
      email: '',
      password: '',
      username: ''
    }
  },
  methods: {
  },
  computed: {
    year () {
      return new Date().getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#footer {
  padding-top: 30px;
  #logoFooter {
    height: 20px;
    width: auto;
  }
  font-size: 14px;
  height: 200px;
  .link {
    text-decoration: none;
    color: $oroGold;
  }
}
</style>
